// Mock data for TEF Canada Trainer

export const userProfile = {
  name: "Estudante TEF",
  plan: "Conta Premium",
  email: "estudante@tefcanada.com",
};

export const dashboardStats = {
  readingAverage: 240,
  listeningAverage: 235,
  writingProductions: 12,
  pendingFlashcards: 48,
  simulationsCompleted: 5,
  streakDays: 14,
};

export const progressData = [
  { name: "Jan", reading: 180, listening: 170, writing: 150 },
  { name: "Feb", reading: 195, listening: 185, writing: 165 },
  { name: "Mar", reading: 210, listening: 205, writing: 180 },
  { name: "Apr", reading: 230, listening: 220, writing: 200 },
  { name: "May", reading: 240, listening: 235, writing: 215 },
];

export const skillsRadar = [
  { subject: "Gramática", A: 85, fullMark: 100 },
  { subject: "Vocabulário", A: 90, fullMark: 100 },
  { subject: "Compreensão", A: 75, fullMark: 100 },
  { subject: "Coerência", A: 70, fullMark: 100 },
  { subject: "Pronúncia", A: 60, fullMark: 100 },
];

export const flashcardsDonut = [
  { name: "Novos", value: 12, fill: "#8b5cf6" }, // primary
  { name: "Aprender", value: 36, fill: "#f59e0b" }, // warning
  { name: "Revisar", value: 85, fill: "#10b981" }, // success
];

export const errorsByCategory = [
  { name: "Concordância", count: 14 },
  { name: "Preposições", count: 23 },
  { name: "Conjugação", count: 8 },
  { name: "Vocabulário", count: 32 },
  { name: "Ortografia", count: 5 },
];

export const recentSimulations = [
  { id: 1, date: "2026-05-01", type: "Reading", score: 240, total: 300 },
  { id: 2, date: "2026-04-28", type: "Listening", score: 235, total: 300 },
  { id: 3, date: "2026-04-25", type: "Writing", status: "Avaliado", level: "B2" },
  { id: 4, date: "2026-04-20", type: "Reading", score: 220, total: 300 },
];

export const questionBank = [
  { id: "q1", competence: "Reading", section: "Section A", difficulty: "Fácil", hasImage: true, hasAudio: false, title: "Anúncio Classificado" },
  { id: "q2", competence: "Listening", section: "Section B", difficulty: "Médio", hasImage: false, hasAudio: true, title: "Mensagem Telefônica" },
  { id: "q3", competence: "Writing", section: "Fait Divers", difficulty: "Difícil", hasImage: false, hasAudio: false, title: "Acidente na autoestrada" },
  { id: "q4", competence: "Reading", section: "Section C", difficulty: "Médio", hasImage: false, hasAudio: false, title: "Texto Argumentativo" },
  { id: "q5", competence: "Listening", section: "Section A", difficulty: "Fácil", hasImage: true, hasAudio: true, title: "Associação de Imagens" },
];

export const historyData = [
  { id: "h1", date: "2026-05-01T10:00:00", competence: "Reading", score: "240/300", timeSpent: "55:00", status: "Concluído", selectedSection: "Documents divers" },
  { id: "h2", date: "2026-04-28T14:30:00", competence: "Listening", score: "235/300", timeSpent: "40:00", status: "Concluído", selectedSection: "Messages vocaux" },
  { id: "h3", date: "2026-04-25T09:15:00", competence: "Writing", score: "N/A", timeSpent: "60:00", status: "Produção salva", words: 245, selectedSection: "Tâche 1" },
];

export const writingErrorsData = [
  { id: "e1", original: "Je suis allé au la plage.", correction: "Je suis allé à la plage.", explanation: "'à la' é a contração correta para preposição + artigo definido feminino singular.", category: "Preposições", context: "Je suis allé au la plage avec mes amis hier." },
  { id: "e2", original: "Beaucoup des personnes...", correction: "Beaucoup de personnes...", explanation: "'Beaucoup de' é invariável quando seguido de um substantivo plural indefinido.", category: "Gramática", context: "Beaucoup des personnes pensent que le français est difficile." },
];

export const vocabularyData = [
  { id: "v1", term: "Néanmoins", meaning: "No entanto, contudo", context: "Il fait froid; néanmoins, je sors.", category: "Conectores", tags: ["avançado", "escrita"] },
  { id: "v2", term: "Atout", meaning: "Trunfo, vantagem", context: "Parler plusieurs langues est un atout majeur.", category: "Substantivo", tags: ["mercado de trabalho"] },
];

export const flashcardsData = [
  { id: "f1", front: "Néanmoins", back: "No entanto, contudo", difficulty: "medium" },
  { id: "f2", front: "Atout", back: "Trunfo, vantagem", difficulty: "hard" },
  { id: "f3", front: "Cependant", back: "Entretanto, todavia", difficulty: "easy" },
];
